/* unplugin-vue-components disabled */import script from "./kpiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./kpiTable.vue?vue&type=script&setup=true&lang=js"

import "./kpiTable.vue?vue&type=style&index=0&id=4d0fc9cb&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d0fc9cb"]])

export default __exports__